const filterByOptions = (data, option1Value, option2Value, selectorCount) => {
  let filteredData;
  if (selectorCount === 2) {
    // Filter data based on option1 only
    filteredData = data.filter(
      (item) =>
        item.option1 === option1Value &&
        !(item.inventory_policy === 'deny' && item.inventory_quantity <= 0)
    );
  } else if (selectorCount === 3) {
    // Filter data based on both option1 and option2
    filteredData = data.filter(
      (item) =>
        item.option1 === option1Value &&
        item.option2 === option2Value &&
        !(item.inventory_policy === 'deny' && item.inventory_quantity <= 0)
    );
  } else {
    filteredData = data.filter(
      (item) =>
        !(item.inventory_policy === 'deny' && item.inventory_quantity <= 0)
    );
  }
  return filteredData;
};

const swatchThumbToggle = (options) => {
  const swatches = document.querySelectorAll('.product-form__swatch button');
  options.forEach((option, index) => {
    // if option is disabled, hide the swatch
    setTimeout(() => {
      if (option.disabled) {
        swatches[index].style.display = 'none';
      } else {
        swatches[index].style.display = 'block';
      }
    }, 250);
  });
};

function dropdownFilter(
  selector,
  filteredVariantData,
  optionKey,
  isUserTriggered
) {
  const selectorOptions = selector.querySelectorAll('option');
  const selectorOptionsArray = Array.from(selectorOptions);
  if (selector.dataset.swatchDropdown === '') {
    swatchThumbToggle(selectorOptions);
  }
  let firstAvailableOption = null;

  // Disable and hide unavailable options
  selectorOptionsArray.forEach((option) => {
    const optionValue = option.value;
    const optionDisabled = filteredVariantData.every(
      (item) => item[optionKey] !== optionValue
    );
    option.disabled = optionDisabled;
    option.hidden = optionDisabled;

    // Check if the current selector value is disabled, and if so, clear it
    if (selector.value === optionValue && optionDisabled) {
      selector.value = ''; // This will clear the selector if the current value is disabled
    }

    // Identify the first available option
    if (!optionDisabled && !firstAvailableOption) {
      firstAvailableOption = optionValue;
    }
  });

  // If no available options were found and the selector was cleared, handle accordingly
  if (!selector.value && firstAvailableOption && isUserTriggered) {
    selector.value = firstAvailableOption;
    selector.dispatchEvent(
      new Event('change', { bubbles: true, composed: true })
    );
    isUserTriggered = false; // Reset flag after dispatching
  }
}

const oosDropdown = (
  variantData,
  selectors,
  firstSelectorValue,
  secondSelectorValue,
  isUserTriggered = false
) => {
  // Filter data by first selector value
  const selectorCount = selectors.length;
  const filteredVariantData = filterByOptions(
    variantData,
    firstSelectorValue,
    secondSelectorValue,
    selectorCount
  );

  // Process single selector
  if (selectors[0] && selectorCount === 1) {
    const selector = selectors[0];
    dropdownFilter(selector, filteredVariantData, 'option1', isUserTriggered);
  }

  if (selectors[1] && selectorCount === 2) {
    const selector = selectors[1];
    dropdownFilter(selector, filteredVariantData, 'option2', isUserTriggered);
  }
  // Process the third selector
  if (selectors[2]) {
    const selector = selectors[2];
    dropdownFilter(selector, filteredVariantData, 'option3', isUserTriggered);
  }
};

/**
 * Constructs a formatted price string based on a base price and quantity.
 * @param {number} price - The base unit price of the item.
 * @param {string} currencySymbol - The symbol representing the currency, e.g., "$".
 * @returns {string} - The formatted total price with currency symbol.
 */
function priceButtonBuilder(price, currencySymbol) {
  // Retrieve the quantity input element from the document
  const quantity = document.querySelector(
    '.product-form__quantity .quantity__input'
  );
  if (!quantity) return;

  // Calculate total price based on the quantity and format to 2 decimal places
  let totalPrice = price * quantity.value;

  // Format the total price with commas for thousands
  let formattedTotalPrice = parseFloat(totalPrice).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${currencySymbol}${formattedTotalPrice}`;
}

/**
 * Updates the content of the button with the new price calculated from the current quantity.
 */
function priceButtonUpdate() {
  // Attempt to retrieve the current price element with two different selectors
  let currentPrice =
    document.querySelector('.price__container [data-price] .money') ||
    document.querySelector('.price__container .money');

  // Early exit if no price element is found
  if (!currentPrice) return;

  // Extract the current price from the element's content and remove any commas
  let priceCurrency = currentPrice.textContent.replace(',', '').split(' ')[0];

  // Parse the price and ensure it's formatted to 2 decimal places
  let priceNoCurrency = parseFloat(priceCurrency.substring(1)).toFixed(2);

  // Extract the currency symbol
  let currencySymbol = priceCurrency.substring(0, 1);

  // Find the button where the new price will be displayed
  const buttonPrice = document.querySelector(
    '.product-form__submit-button .money'
  );

  // Update the button text with the new price using the priceButtonBuilder function
  if (buttonPrice) {
    buttonPrice.textContent = priceButtonBuilder(
      priceNoCurrency,
      currencySymbol
    );
  }
}

const pdpFormUpdates = () => {
  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  const variantData = JSON.parse(
    variantSelects.querySelector('[type="application/json"]').textContent
  );

  const selectors = variantSelects.querySelectorAll('select');

  selectors.forEach((select) => {
    select.addEventListener('change', () => {
      oosDropdown(
        variantData,
        selectors,
        selectors[0].value,
        selectors[1]?.value,
        true
      );
      setTimeout(() => {
        priceButtonUpdate();
      }, 1000);
    });
  });
  oosDropdown(
    variantData,
    selectors,
    selectors[0].value,
    selectors[1]?.value,
    false
  );
};

export const variantFunctions = (slug) => {
  pdpFormUpdates();
};
